export default __webpack_public_path__ + "static/media/simag.2d7b48d9.png";